import React, { useState, useEffect } from 'react';
import { FormControlLabel, Switch, Tooltip, Typography, Button, Box } from '@mui/material';
import { PlayArrow } from '@mui/icons-material';
import { useTour } from '../../contexts/TourContext';
import { useLocation } from 'react-router-dom';

const TourButton: React.FC = () => {
  const [tourEnabled, setTourEnabled] = useState(false);
  const { startTour, startTourFromBeginning, resetDismissedTours, clearTourCache, getTourForCurrentRoute } = useTour();
  const location = useLocation();

  useEffect(() => {
    const savedState = localStorage.getItem('tourEnabled');
    if (savedState !== null) {
      setTourEnabled(savedState === 'true');
    }
  }, []);

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newState = event.target.checked;
    setTourEnabled(newState);
    localStorage.setItem('tourEnabled', String(newState));
  };

  const handleRestartTour = () => {
    // Try to get tour dynamically first
    const currentTour = getTourForCurrentRoute();
    let tourName = '';
    
    if (currentTour) {
      // Dynamic system found a tour
      tourName = currentTour.name;
    } else {
      // Fallback to hardcoded mapping (for backward compatibility)
      switch (location.pathname) {
        case '/payroll/config':
          tourName = 'payroll-config';
          break;
        case '/projects':
          tourName = 'projects';
          break;
        case '/dashboard':
          tourName = 'dashboard';
          break;
        default:
          // Try to find a tour for the current page
          tourName = location.pathname.split('/').pop() || '';
      }
    }
    
    // Clear localStorage items
    localStorage.removeItem('dismissedTours');
    localStorage.removeItem('tourStates');
    
    // Clear tour cache to ensure fresh start
    if (tourName) {
      clearTourCache(tourName);
    }
    
    // Start the tour from beginning after a short delay
    setTimeout(() => {
      if (tourName) {
        startTourFromBeginning(tourName);
      }
    }, 100);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title="نمایش مجدد تور آموزشی از ابتدا">
        <Button
          variant="contained"
          size="small"
          startIcon={<PlayArrow />}
          onClick={handleRestartTour}
          sx={{ 
            minWidth: 'auto', 
            fontSize: '0.75rem', 
            py: 0.5,
            backgroundColor: '#ff9800',
            color: 'white',
            '&:hover': {
              backgroundColor: '#f57c00',
            },
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
          }}
        >
          مجدد
        </Button>
      </Tooltip>
      
      <Tooltip title="فعال/غیرفعال کردن تور آموزشی">
        <FormControlLabel
          control={
            <Switch
              checked={tourEnabled}
              onChange={handleToggle}
              color="primary"
              size="small"
            />
          }
          label={
            <Typography variant="body2" sx={{ fontSize: '0.8rem', ml: 0.5 }}>
              تور
            </Typography>
          }
          sx={{ ml: 1, mr: 0 }}
        />
      </Tooltip>
    </Box>
  );
};

export default TourButton;
